// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-masonry-grid {
    display: flex;
    width: 100%;
    overflow-y: auto;
    height: calc(100dvh - 150px);
    gap: 7px;
}

.masonary-item {
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.video-item {
    width: 100%;
    object-fit: contain;
    height: 100%;
}

.my-masonry-grid_column {
    gap: 7px;
    display: flex;
    flex-direction: column;
}

.popup-content {
    border-radius: 10px;
    padding: 16px;
    max-width: 90vw;
    max-height: 90vh;
    position: relative;
}

.masonry-item {
    width: 100%;
    cursor: pointer;
}

.library-popup {
    border-radius: 16px;
    width: 90vw;
    position: relative;
    background-color: #2B2F54;
}

.search-input .MuiInputBase-input {
    color: white;
}

.search-input label,
.search-input .MuiInputLabel-root {
    color: white;
}

.search-input .MuiOutlinedInput-root {
    border-radius: 8px;
}

.search-input .MuiOutlinedInput-root fieldset {
    border-color: #ebebf599;
    border-radius: 8px;
}

.search-input .MuiOutlinedInput-root:hover fieldset {
    border-color: #ebebf599;
}

.search-input .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: #ebebf599;
}

.search-icon {
    color: #ebebf599;
}

.search-input input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #282B4E inset;
    -webkit-text-fill-color: white;
    background-color: #282B4E !important;
}

.search-input input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #282B4E inset;
    -webkit-text-fill-color: white;
    background-color: #282B4E !important;
}

/* drawer */
.custom-drawer {
    width: 300px;
    flex-shrink: 0;
}

.custom-drawer .MuiDrawer-paper {
    box-sizing: border-box;
    background-color: #1f1f3d;
    color: white;
    padding: 16px;
    margin-top: 16px;
    border-radius: 8px;
    overflow-x: hidden;
    transition: width 0.3s;
    height: calc(100dvh - 150px);
    overflow-y: auto;
}
.custom-drawer .MuiPaper-root{
    position: relative;
}

/* basic Popup */
.popup-overlay{
    position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-content{
    position: relative;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  padding: 16px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MuiButtonBase-root.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #333;
  z-index: 10;
}
.video-content {
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 8px;
}
.menuIcon{
width: 30px;
height: 30px;
color: white;
}
.MuiBox-root.cofimationButton{ 
    display: flex;
    gap: 10px;
    align-items: center;
}
@media screen and (min-width: 768px) {
   .MuiBox-root.cofimationButton{
        width: 100%;
        justify-content: end;
   }
    
}
@media screen and (min-width: 768px) {
.my-masonry-grid_column {
    width: 50%;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Library/Library.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,eAAe;EACjB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;IACI,kBAAkB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;AACA,WAAW;AACX,YAAY;AACZ,YAAY;AACZ;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;GACG;QACK,WAAW;QACX,oBAAoB;GACzB;;AAEH;AACA;AACA;IACI,UAAU;AACd;AACA","sourcesContent":[".my-masonry-grid {\n    display: flex;\n    width: 100%;\n    overflow-y: auto;\n    height: calc(100dvh - 150px);\n    gap: 7px;\n}\n\n.masonary-item {\n    overflow: hidden;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.video-item {\n    width: 100%;\n    object-fit: contain;\n    height: 100%;\n}\n\n.my-masonry-grid_column {\n    gap: 7px;\n    display: flex;\n    flex-direction: column;\n}\n\n.popup-content {\n    border-radius: 10px;\n    padding: 16px;\n    max-width: 90vw;\n    max-height: 90vh;\n    position: relative;\n}\n\n.masonry-item {\n    width: 100%;\n    cursor: pointer;\n}\n\n.library-popup {\n    border-radius: 16px;\n    width: 90vw;\n    position: relative;\n    background-color: #2B2F54;\n}\n\n.search-input .MuiInputBase-input {\n    color: white;\n}\n\n.search-input label,\n.search-input .MuiInputLabel-root {\n    color: white;\n}\n\n.search-input .MuiOutlinedInput-root {\n    border-radius: 8px;\n}\n\n.search-input .MuiOutlinedInput-root fieldset {\n    border-color: #ebebf599;\n    border-radius: 8px;\n}\n\n.search-input .MuiOutlinedInput-root:hover fieldset {\n    border-color: #ebebf599;\n}\n\n.search-input .MuiOutlinedInput-root.Mui-focused fieldset {\n    border-color: #ebebf599;\n}\n\n.search-icon {\n    color: #ebebf599;\n}\n\n.search-input input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px #282B4E inset;\n    -webkit-text-fill-color: white;\n    background-color: #282B4E !important;\n}\n\n.search-input input:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0px 1000px #282B4E inset;\n    -webkit-text-fill-color: white;\n    background-color: #282B4E !important;\n}\n\n/* drawer */\n.custom-drawer {\n    width: 300px;\n    flex-shrink: 0;\n}\n\n.custom-drawer .MuiDrawer-paper {\n    box-sizing: border-box;\n    background-color: #1f1f3d;\n    color: white;\n    padding: 16px;\n    margin-top: 16px;\n    border-radius: 8px;\n    overflow-x: hidden;\n    transition: width 0.3s;\n    height: calc(100dvh - 150px);\n    overflow-y: auto;\n}\n.custom-drawer .MuiPaper-root{\n    position: relative;\n}\n\n/* basic Popup */\n.popup-overlay{\n    position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.popup-content{\n    position: relative;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  padding: 16px;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.MuiButtonBase-root.close-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  color: #333;\n  z-index: 10;\n}\n.video-content {\n  max-width: 80vw;\n  max-height: 80vh;\n  border-radius: 8px;\n}\n.menuIcon{\nwidth: 30px;\nheight: 30px;\ncolor: white;\n}\n.MuiBox-root.cofimationButton{ \n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n@media screen and (min-width: 768px) {\n   .MuiBox-root.cofimationButton{\n        width: 100%;\n        justify-content: end;\n   }\n    \n}\n@media screen and (min-width: 768px) {\n.my-masonry-grid_column {\n    width: 50%;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
